
import api from "@/utils/api";
import {
    EventBus,
    // logOut
} from '@/utils/utils';
import { store } from '@/store/store';
import { URL } from '@/utils/globals';

var restful = {
    Get(url, config = {}) {
        EventBus.startLoad();
        return new Promise((resolve, reject) => {
            api.get(url, config).then(response => {
                EventBus.endLoad();
                if (response.status != 200) {
                    console.log(`Error obteniendo url ${url}. `, response);
                    reject(response);
                    return;
                }
                // Si es responseType blob, devolver la respuesta completa
                if (config.responseType === 'blob') {
                    resolve(response);
                    return;
                }
                if (Object.keys(response.data).includes("error")) {
                    console.log("Error controlado. ", response.data.error);
                    reject(response.data);
                    return;
                }
                resolve(response.data);
            }).catch(error => {
                EventBus.endLoad();
                console.log(error);

                // // Verificar si es un error 401 y el usuario está logueado
                // if (error.response && error.response.status === 401 && store.getters.isLoged) {
                //     this.handleUnauthorized()
                //         .then(() => reject(error))
                //         .catch(() => reject(error));
                // } else {
                //     reject(error);
                // }
            });
        });
    },
    GetAll(url_base, config = {}) {
        // Acumula TODAS las páginas de un endpoint paginado (BasePagination:
        // {count, next, previous, results}) siguiendo `next` — reemplaza
        // all_data=True: ninguna request individual supera page_size. Secuencial
        // a propósito: sin ráfagas paralelas y sin aritmética sobre `count`
        // (que puede cambiar entre páginas). El caller debe incluir un
        // `ordering` estable (p. ej. &ordering=id) si el endpoint lo soporta,
        // para que los cortes de página sean deterministas.
        // 250 = the backend cap (API_MAX_PAGE_SIZE: 500 on 2026-09-20, 250 on 2026-10-02);
        // asking for more only gets clamped and logged as pagination_clamp on every pull.
        const page_size = config.page_size || 250;
        const base = url_base.replace('?&', '?');
        const sep = /[?&]$/.test(base) ? '' : base.includes('?') ? '&' : '?';
        const page_url = (page) => `${base}${sep}page=${page}&page_size=${page_size}`;
        const walk = (page, rows) => this.Get(page_url(page)).then((response) => {
            if (Array.isArray(response)) return rows.concat(response);
            rows.push(...(response.results || []));
            return response.next ? walk(page + 1, rows) : rows;
        });
        return walk(1, []);
    },
    Post(url, item, config = {}) {
        return new Promise((resolve, reject) => {
            api.post(url, item, config).then(response => {
                if (response.status != 201 && response.status != 200) {
                    console.log(`Error creando. url ${url}. `, response);
                    reject(response);
                    return;
                }
                // Si es responseType blob, devolver la respuesta completa para acceder a response.data
                if (config.responseType === 'blob') {
                    resolve(response);
                } else {
                    resolve(response.data);
                }
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    Put(url, item) {
        return new Promise((resolve, reject) => {
            api.put(url, item).then(response => {
                if (response.status != 200) {
                    console.log(`Error actualizando. url ${url}. `, response);
                    reject(response);
                    return;
                }
                resolve(response.data);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    Patch(url, item) {
        return new Promise((resolve, reject) => {
            api.patch(url, item).then(response => {
                if (response.status != 200) {
                    console.log(`Error patching. url ${url}. `, response);
                    reject(response);
                    return;
                }
                resolve(response.data);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    Delete(url) {
        return new Promise((resolve, reject) => {
            api.delete(url).then(response => {
                if (response.status != 204) {
                    console.log(`Error eliminando. url ${url}. `, response);
                    reject(response);
                    return;
                }
                resolve(response.data);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    PostStream(url, item, config = {}) {
        return fetch(`${URL}${url}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${store.state.jwt_token}`,
            },
            body: JSON.stringify(item),
            ...config,
        }).then(response => {
            if (!response.ok && response.status !== 429 && response.status !== 403)
                throw new Error(`HTTP error! status: ${response.status}`);
            return response;
        });
    },

    // async handleUnauthorized() {
    //     try {
    //         // Obtener el usuario actual del store
    //         const currentUser = store.state.user;
    //         if (!currentUser || !currentUser.id) {
    //             console.log('No hay usuario actual para verificar must_relog');
    //             return;
    //         }

    //         // Usar la instancia de api directamente para evitar recursión
    //         // y también usar un endpoint que no requiera autenticación si es posible
    //         const response = await api.get(`/authentication/user/${currentUser.id}/`);
    //         const updatedUser = response.data;

    //         // Verificar si el usuario tiene must_relog
    //         if (updatedUser.must_relog === true) {
    //             console.log('Usuario tiene must_relog activado, ejecutando logout...');

    //             // Ejecutar logout
    //             logOut();

    //             // Mostrar mensaje al usuario si SweetAlert está disponible
    //             if (window.Vue && window.Vue.swal) {
    //                 window.Vue.swal.fire({
    //                     title: 'Reiniciar Sesión',
    //                     text: 'Es necesario volver a iniciar sesión. Por favor, ingresa nuevamente con tus credenciales.',
    //                     icon: 'warning',
    //                     confirmButtonText: 'Entendido'
    //                 });
    //             }
    //         } else {
    //             console.log('Usuario no tiene must_relog, continuando...');

    //             // Si no tiene must_relog, podríamos actualizar el usuario en el store
    //             store.commit('setUser', updatedUser);
    //         }
    //     } catch (fetchError) {
    //         console.error('Error al obtener datos actualizados del usuario:', fetchError);

    //         // Si también falla la petición de verificación, significa que realmente
    //         // hay un problema de autenticación, así que hacer logout
    //         if (fetchError.response && fetchError.response.status === 401) {
    //             console.log('Token realmente inválido, ejecutando logout...');
    //             logOut();
    //         }
    //     }
    // }
};

export default restful;
